module.exports = __webpack_public_path__ + "img/dgbip.1b0e2a93.png";